import ReactTooltip from 'react-tooltip';
import I18n from '../../config/i18n';
import './CapacityIcons.css';

const bedIcon = (
  <svg width="512px" height="448px" viewBox="0 0 512 448" xmlns="http://www.w3.org/2000/svg">
    <path d="M32,48 C32,21.49 53.49,0 80,0 L432,0 C458.5,0 480,21.49 480,48 L480,173.8 C465.5,166.2 449.2,161.4 432,160.3 L402,160 L402,128 C402,110.3 387.7,96 370,96 L142,96 C124.33,96 110,110.3 110,128 L110,160 L90,160.3 C72.75,161.4 46.5,166.2 32,173.8 L32,48 Z M424,192 C472.6,192 512,231.4 512,280 L512,424 C512,437.3 501.3,448 488,448 C474.7,448 464,437.3 464,424 L464,384 L48,384 L48,424 C48,437.3 37.25,448 24,448 C10.75,448 0,437.3 0,424 L0,280 C0,231.4 39.4,192 88,192 L424,192 Z M464,280 C464,257.9 446.1,240 424,240 L88,240 C65.91,240 48,257.9 48,280 L48,336 L464,336 L464,280 Z" />
  </svg>
);
const personIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M272 304h-96C78.8 304 0 382.8 0 480c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32C448 382.8 369.2 304 272 304zM48.99 464C56.89 400.9 110.8 352 176 352h96c65.16 0 119.1 48.95 127 112H48.99zM224 256c70.69 0 128-57.31 128-128c0-70.69-57.31-128-128-128S96 57.31 96 128C96 198.7 153.3 256 224 256zM224 48c44.11 0 80 35.89 80 80c0 44.11-35.89 80-80 80S144 172.1 144 128C144 83.89 179.9 48 224 48z" />
  </svg>
);
const bathIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M344.1 87.03c-9.375-9.375-24.56-9.375-33.94 0L310.2 87.84l-7.031-7.031C281.3 58.94 252.7 48 224 48c-21.57 0-43.13 6.211-61.8 18.6L145.3 52.53C129.4 39.28 109.3 32 88.61 32C39.75 32 0 71.75 0 120.6V456C0 469.3 10.75 480 24 480s24-10.75 24-24V120.6C48 98.22 66.22 80 88.61 80c9.469 0 18.7 3.344 26 9.406l14.29 11.91c-26.67 43.18-21.54 100.4 15.9 137.9L151.8 246.2L151 247c-9.375 9.375-9.375 24.56 0 33.94C155.7 285.7 161.9 288 168 288s12.28-2.344 16.97-7.031l160-160C354.3 111.6 354.3 96.41 344.1 87.03zM185.8 212.3L178.7 205.3c-24.95-24.95-24.95-65.55 .002-90.51C190.8 102.7 206.9 96 224 96c17.09 0 33.17 6.656 45.26 18.75l7.031 7.029L185.8 212.3zM480 192c-17.67 0-32 14.33-32 32c0 17.67 14.33 32 32 32s32-14.33 32-32C512 206.3 497.7 192 480 192zM288 384c-17.67 0-32 14.33-32 32c0 17.67 14.33 32 32 32s32-14.33 32-32C320 398.3 305.7 384 288 384zM352 320c-17.67 0-32 14.33-32 32c0 17.67 14.33 32 32 32s32-14.33 32-32C384 334.3 369.7 320 352 320zM416 256c-17.67 0-32 14.33-32 32c0 17.67 14.33 32 32 32s32-14.33 32-32C448 270.3 433.7 256 416 256zM288 320c0-17.67-14.33-32-32-32s-32 14.33-32 32c0 17.67 14.33 32 32 32S288 337.7 288 320zM320 224c-17.67 0-32 14.33-32 32c0 17.67 14.33 32 32 32s32-14.33 32-32C352 238.3 337.7 224 320 224zM384 224c17.67 0 32-14.33 32-32c0-17.67-14.33-32-32-32s-32 14.33-32 32C352 209.7 366.3 224 384 224z" />
  </svg>
);

interface CapacityIconProps {
  icon: JSX.Element;
  count: number;
  tooltipText: string;
}

function CapacityIcon({ icon, count, tooltipText }: CapacityIconProps): JSX.Element | null {
  if (!count) {
    return null;
  }
  return (
    <div className="capacity-icons__icon">
      <span data-tip={tooltipText} data-background-color="#009ac6">
        <div className="capacity-icons__iconimg">{icon}</div>
        <div className="capacity-icons__count">{count}</div>
        <ReactTooltip />
      </span>
    </div>
  );
}

interface CapacityIconsProps {
  numberOfRooms: number;
  maxPersons: number;
  numberOfBaths: number;
}

export default function CapacityIcons({
  numberOfRooms,
  maxPersons,
  numberOfBaths,
}: CapacityIconsProps): JSX.Element {
  return (
    <div className="capacity-icons">
      <CapacityIcon
        icon={personIcon}
        count={maxPersons}
        tooltipText={I18n.t('host_teaser.number_of_persons')}
      />
      <CapacityIcon
        icon={bedIcon}
        count={numberOfRooms}
        tooltipText={I18n.t('host_teaser.number_of_rooms')}
      />
      <CapacityIcon
        icon={bathIcon}
        count={numberOfBaths}
        tooltipText={I18n.t('host_teaser.number_of_baths')}
      />
    </div>
  );
}
